import { Router } from 'react-router-dom';
import { apiRequest } from '../../utils/config/apiRequest';
import { _otpFor } from '../../utils/Constant';
import { apiUrl } from '../../utils/endPoints/apiUrl';
import { mobileRegex, emailRegex } from '../../utils/regex/formRegexConstant';
import { aboutYouValidation } from './validations';
import { useNavigate } from "react-router-dom";
import { useState } from 'react';

const AboutYou = ({ formik, setSideBarState, setOtpToken }) => {
    // const navigate = useNavigate();
    const handleNext = async (e) => {
        try {
            e.preventDefault();
            // ✅ validate form values
            await aboutYouValidation.validate(formik.values, { abortEarly: false });

            // ✅ call API after successful validation
            const { status, message, data } = await apiRequest({
                endUrl: apiUrl.mobileOtp,
                method: 'POST',
                body: {
                    dialCode: formik.values.dialCode || "1",
                    mobileNo: formik.values.mobile,
                    otpFor: _otpFor.USER_REGISTRATION
                },
                showMsg: true
            });
            if (status) {
                // ✅ if API is successful → move to next step
                setSideBarState((prev) => ({
                    ...prev,
                    aboutCompany: { isCompleted: true, isActive: false },
                    aboutYou: { isCompleted: true, isActive: false },
                    mobileOtp: { isCompleted: false, isActive: true },
                    setPassword: { isCompleted: false, isActive: false },
                }));
                setOtpToken((prev) => ({
                    ...prev,
                    mobile: data.otpToken,
                }));

            } else {
                throw new Error("Something went wrong >>>>>>>>");
            }

        } catch (error) {
            if (error.inner) {
                // Map Yup validation errors into Formik errors
                const formikErrors = error.inner.reduce((acc, err) => {
                    if (err.path) {
                        acc[err.path] = err.message;
                    }
                    return acc;
                }, {});

                // ✅ Set Formik's errors
                formik.setErrors(formikErrors);
            } else {
                console.error("Unexpected error:", error);
            }
        }
    };

    const handleBack = () => {
        // Update sidebar state to mark AboutYou as inactive and activate AboutCompany
        setSideBarState((prevState) => ({
            aboutCompany: { isCompleted: true, isActive: true },
            aboutYou: { isCompleted: false, isActive: false },
            mobileOtp: { isCompleted: false, isActive: false },
            emailOtp: { isCompleted: false, isActive: false },
            setPassword: { isCompleted: false, isActive: false },
        }));
    }

    const { values, touched, errors, setFieldValue, handleSubmit } = formik;
    return (
        <div className="col-md-8 px-5">
            <form onSubmit={(e) => handleNext(e)}>
                <div className="row mt-5 px-5">
                    <div className="col-md-12">
                        <div className="about-section">
                            <h4>Who are you?</h4>
                            <p>Signup - company</p>
                        </div>

                    </div>

                    <div className="col-md-12 mt-3">
                        <label htmlFor="" className="label-input mb-1">Full name</label> <br />
                        <input
                            type="text"
                            className="form-control login-input"
                            placeholder="Enter Full name"
                            onChange={(e) => {
                                const alphabeticValue = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                setFieldValue("fullName", alphabeticValue);
                            }}
                            value={values.fullName}

                        />
                        {errors.fullName && (
                            <div className="text-danger">{errors.fullName}</div>
                        )}
                    </div>

                    <div className="col-md-12 mt-3">
                        <label htmlFor="" className="label-input mb-1">Your email</label> <br />
                        <div className="position-relative">
                            <input
                                type="email"
                                className="form-control login-input"
                                placeholder="Enter email address"
                                onChange={(e) => setFieldValue("email", e.target.value)}
                                value={values.email}

                            />
                            {values.email && emailRegex.test(values.email) && (
                                <img src="images/rightcheck.svg" alt="" style={{ right: '10px', top: '15px', position: 'absolute' }} />
                            )}
                        </div>
                        {errors.email && (
                            <div className="text-danger small mt-1">{errors.email}</div>
                        )}
                    </div>

                    <div className="col-md-12 mt-3">
                        <label htmlFor="" className="label-input mb-1">Your mobile</label>
                        <div className="mobile-input-wrapper">
                            <div className="country-code">
                                <select
                                    onChange={(e) => setFieldValue("dialCode", e.target.value)}
                                >
                                    <option defaultValue value={"+1"}>+1</option>
                                    <option value={"+91"}>+91</option>
                                    <option value={"+44"}>+44</option>
                                </select>
                            </div>
                            <input
                                type="text"
                                className={`phone-input ${touched.mobile && errors.mobile ? 'is-invalid' : ''}`}
                                placeholder="2124567890"
                                onChange={(e) => {
                                    const numericValue = e.target.value.replace(/\D/g, '');
                                    setFieldValue("mobile", numericValue);
                                }}
                                value={values.mobile}
                                maxLength="10"
                            />
                            {values.mobile && mobileRegex.test(values.mobile) && (
                                <img src="images/rightcheck.svg" className="mr-2" alt="Valid" />
                            )}
                        </div>
                        {errors.mobile && (
                            <div className="text-danger small mt-1">{errors.mobile}</div>
                        )}
                    </div>

                    <div className="col-md-6 mb-5 mt-5 pt-5">
                        <button type="button" className="btn btn-dark back-btn" onClick={() => handleBack()}>Back</button>
                    </div>

                    <div className="col-md-6 mb-5 mt-5 pt-5">
                        <button type="submit" className="btn btn-dark login-btn" >Next</button>
                    </div>

                    <div className="col-md-12 pb-4">
                        <p className="text-center foot-text">Existing user? <a href="#"
                            style={{ textDecoration: 'underline' }}>Sign In</a></p>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default AboutYou
